module.exports = __webpack_public_path__ + "img/overview_img_bottom.0f8f84a3.svg";